import React, { ReactNode } from "react";
import SiderBar from "./Sidebar/Sidebar.tsx";
import "./mainlayout.css"

interface MainLayoutProps {
  children: ReactNode;
}

const MainLayout: React.FC<MainLayoutProps> = ({ children }) => {

  return (
    <>
      {/* Sidebar */}
      <div className="app-body">
        <div className="sidebar--div">
          <SiderBar />
        </div>
        <div className="app-body--content">
          {children}
        </div>
      </div>
    </>
  );
};

export default MainLayout;
